import { Component, ElementRef } from '@angular/core';
import {
  ConfirmDialogData,
  DialogBase,
  DialogRef,
  DialogResult,
  DialogService,
  HotkeyService,
} from '@kpd/framework-ngx';

@Component({
  selector: 'app-alert-dialog-large',
  templateUrl: './alert-dialog-large.component.html',
})
export class LargeAlertComponent extends DialogBase {
  static key = 'large-alert';

  message = 'Oops! Something went wrong';
  verify = DialogResult.Verify;
  discard = DialogResult.Discard;
  verifyLabel = 'Ok';
  severity = 'info';
  severityIcon = 'info-standard';
  severityColor = 'alert-dialog--info color-info';
  shake = false;
  shakeStyle = '';

  constructor(dialogService: DialogService, element: ElementRef, hotKeyService: HotkeyService) {
    super(LargeAlertComponent.key, dialogService, element, hotKeyService);
  }

  onBeforeShow(dialogRef: DialogRef): void {
    const data = dialogRef.data as ConfirmDialogData;
    if (data.message) {
      this.message = data.message;
    }
    if (data.header) {
      this.header = data.header;
    }
    this.severityIcon = 'info-standard';
    this.severityColor = 'info';
  }
}
